import React from "react";
import AudienceSelection from "../components/audience-selection";
import {
  useGetListsQuery,
  useKickoffSyncMutation,
  useLoadSessionQuery,
  useSaveSelectedListMutation,
} from "../features/mc-square-api/mc-square-api-slice";
import { UNKNOWN_USER } from "../constants/proptypes";

const AudienceSelectionContainer = () => {
  const [triggerSaveSelectedList, { isLoading: savingSelectedList }] =
    useSaveSelectedListMutation();
  const [kickoffInitialSync] = useKickoffSyncMutation();

  const {
    data: { lists, constraints: { mayCreate: canCreateList } } = {
      lists: [],
      constraints: { mayCreate: false },
    },
    isFetching: fetchingLists,
    isError: errorLoadingLists,
  } = useGetListsQuery();

  const { data: { id, mailchimpList } = UNKNOWN_USER } = useLoadSessionQuery();

  if (!id) return null;

  return (
    <AudienceSelection
      lists={lists}
      fetchingLists={fetchingLists}
      canCreateList={canCreateList}
      errorLoadingLists={errorLoadingLists}
      selectedList={mailchimpList}
      saveSelectedList={triggerSaveSelectedList}
      savingSelectedList={savingSelectedList}
      kickoffInitialSync={kickoffInitialSync}
    />
  );
};

AudienceSelectionContainer.propTypes = {};

export default AudienceSelectionContainer;
